import { BLOCK_CONTACT_TYPE, UNBLOCK_CONTACT_TYPE } from '../../../../Helpers/Chat/Constant';
import { formatUserIdToJid } from '../../../../Helpers/Chat/ChatHelper';
import { store } from '../../../../Redux/store';
import { addBlockedContact } from '../../../../Redux/feature/blockContactSlice';
import { addContactsWhoBlockedMe } from '../../../../Redux/feature/contactsWhoBlockedMeSlice';

/**
 * Action to add the contacts who I blocked
 * @param {*} data - [userjid1, userjid, ...]
 */
/**
// export const blockedContactAction = (data) => {
//     return dispatch => {
//         dispatch({
//             type: BLOCK_DATA,
//             payload: {
//                 id: uuidv4(),
//                 data: data || []
//             }
//         });
//     };
// }
*/

/**
 * Action to update the contacts who I blocked
 * @param {*} userJid
 * @param {*} blockType
 */
export const updateBlockedContactAction = (userJid, blockType = BLOCK_CONTACT_TYPE) => {
    const state = store.getState();
    console.log("state",state)
    let userJids = formatUserIdToJid(userJid);
    let blockedContact = Object.assign([], state.blockedContact.data);
    const blockedContactIndex = blockedContact.indexOf(userJids);  
    if(blockType === BLOCK_CONTACT_TYPE && blockedContactIndex === -1){
        blockedContact.push(userJids)
    }

    if(blockType === UNBLOCK_CONTACT_TYPE && blockedContactIndex > -1){
        blockedContact.splice(blockedContactIndex, 1);
    }
    store.dispatch(addBlockedContact(blockedContact));
}

/**
 * Action to add the contacts who blocked me
 * @param {Array} data - [userjid1, userjid, ...]
 */
/**
// export const contactWhoBlockedMeAction = (data) => {
//     return dispatch => {
//         dispatch({
//             type: CONTACT_WHO_BLOCKED_ME,
//             payload: {
//                 id: uuidv4(),
//                 data: data || []
//             }
//         });
//     };
// }
*/

/**
 * Action to update the contacts who blocked me
 * @param {*} userJid
 * @param {*} blockType
 */
export const updateContactWhoBlockedMeAction = (userJid, blockType = BLOCK_CONTACT_TYPE) => {
    const state = store.getState();
    let userJids = formatUserIdToJid(userJid);
    let contactsWhoBlockedMe = Object.assign([], state.blockedContact.data);
    const blockedContactIndex = contactsWhoBlockedMe.indexOf(userJids);
    if(blockType === BLOCK_CONTACT_TYPE && blockedContactIndex === -1){
        contactsWhoBlockedMe.push(userJids);
    }

    if(blockType === UNBLOCK_CONTACT_TYPE && blockedContactIndex > -1){
        contactsWhoBlockedMe.splice(blockedContactIndex, 1);
    }
    store.dispatch(addContactsWhoBlockedMe(contactsWhoBlockedMe));
}
